import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
// import Login from './LoginComponent/Login';
import LoginContainer from './LoginComponent/LoginContainer';
import Logout from './LoginComponent/Logout';
// import ForgotPassword from './LoginComponent/ForgotPassword_old';
// import ResetPassword from './LoginComponent/ResetPassword_old';
import Home from './Home';
import DashboardParent from './DashBoardParent';
import AdminParent from '../../adminpanel/components/AdminParent';
// import NoDataFound from './commonComponents/NoDataFound';
import ParentRoute from './Admin-version2/ParentRoute';

import { connect } from 'react-redux';

const Routes = ({ authData, dataResult, dataSet }) => {

	const [pageError, setPageError] = useState(true)

	useEffect(() => {
		setTimeout(() => {
			feather.replace()
        }, 1000);
	}, [window.location.href])

	var extraInfo = authData ? authData.extraInfo ? JSON.parse(authData.extraInfo) : null : null;
	SKIN_NAV = extraInfo ? (extraInfo.SKIN_NAV ? extraInfo.SKIN_NAV : SKIN_NAV) : SKIN_NAV;
	SKIN_MODE = extraInfo ? (extraInfo.SKIN_MODE ? extraInfo.SKIN_MODE : SKIN_MODE) : SKIN_MODE;
	logo = extraInfo ? (extraInfo.logo ? extraInfo.logo : logo) : logo;
	SESSION_CHECK = process.env.SESSION_CHECK
	setCSSComp(process.env, 'all');

	let AdminParentComponent = AdminParent;
	let AdminSecondVersionParent = ParentRoute;
	if (dataResult.length > 0) {
		if (dataSet.userType != '1') {
			AdminParentComponent = DashboardParent;
			AdminSecondVersionParent = DashboardParent;
		}
	}
	var landingParent = DashboardParent;
	appType = appType ? appType : process.env.appType;
	let subDomain = window.location.hostname.split('.')[0];
	appType = appType ? appType : subDomain;

	if (appType && appType.toLowerCase() == 'admin')
		landingParent = AdminParentComponent;

	return (
		<BrowserRouter>
			<Switch>
				<Route exact path="/workspace" component={LoginContainer} />
				<Route exact path="/login" component={LoginContainer} />
				<Route
					exact
					path="/login/(forgotpassword|resetpassword|forgotworkspace|register)"
					component={LoginContainer}
				/>
				<Route exact path="/accounts/user/login" component={LoginContainer} />
				<Route exact path="/logout" component={Logout} />
				<Route path="/admin" component={AdminParentComponent} />
				<Route path="/adminpanel/v2" component={AdminSecondVersionParent} />
				<Route path="/" component={landingParent} />
			</Switch>
		</BrowserRouter>
	);
}

function mapStateToProps(state) {
	return {
		authData: state.dataSet.authData,
		dataResult: state.dataSet.dataResult,
		dataSet: state.dataSet.dataSet
	};
}
export default connect(mapStateToProps, null)(Routes);
